var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "750", persistent: "", "overlay-opacity": "0.6" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.currentPopup
        ? _c(
            "v-card",
            { staticClass: "popup-overlay-card" },
            [
              _vm.currentPopup.image_url
                ? _c("v-img", {
                    staticClass: "grey lighten-3",
                    attrs: {
                      src: _vm.currentPopup.image_url,
                      "max-height": "320",
                      contain: "",
                    },
                  })
                : _vm._e(),
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold pt-4 pb-1" },
                [_vm._v(" " + _vm._s(_vm.currentPopup.title) + " ")]
              ),
              _vm.currentPopup.message
                ? _c(
                    "v-card-text",
                    {
                      staticClass: "text-body-2 pb-2",
                      staticStyle: { "white-space": "pre-line" },
                    },
                    [_vm._v(" " + _vm._s(_vm.currentPopup.message) + " ")]
                  )
                : _vm._e(),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _vm.popups.length > 1
                    ? _c(
                        "span",
                        { staticClass: "text-caption grey--text ml-2" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.currentIndex + 1) +
                              " de " +
                              _vm._s(_vm.popups.length) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.dismiss } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.isLast ? "Fechar" : "Próximo") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }